import { httpApi } from 'api/http.api';
import { AxiosResponse } from 'axios';
import { User } from 'types';
import {
  UserCreatePayloadType,
  UserUpdatePayloadType,
  EmployeeWithScheduleOfToday,
  UpcomingEmployeeEvent,
} from 'types/user';
import { ResponseGeneral } from 'types';

const controller = `user`;

export type badFormat = {
  reason: {
    msg: string;
    user: string;
  };
};

export type ResponseExcelType = {
  succesMsg: string;
  failedMsg: string;
};

export type GetAllUsersParams = {
  filter?: string;
  currentActiveContractOnly?: boolean;
};

export type UserProfileRequirements = {
  seniorityDateRequired: boolean;
};

export const createOne = (
  user: UserCreatePayloadType
): Promise<AxiosResponse<User>> =>
  httpApi.post<User>(`${controller}`, { ...user }).then((res) => res);

export const getOne = (id: string): Promise<AxiosResponse<User>> => {
  return httpApi.get<User>(`${controller}/${id}`, {}).then((res) => res);
};

export const getProfileRequirements = (
  id: string
): Promise<UserProfileRequirements> =>
  httpApi
    .get<UserProfileRequirements>(`${controller}/${id}/profile-requirements`)
    .then((res) => res.data);

export const registryByExcel = (
  idFile: string
): Promise<AxiosResponse<ResponseExcelType | badFormat[]>> => {
  return httpApi
    .get<ResponseExcelType | badFormat[]>(`${controller}/excel/${idFile}`)
    .then((res) => res);
};
export const udpateOne = (
  dataPayload: UserUpdatePayloadType
): Promise<AxiosResponse<User>> =>
  httpApi
    .put<User>(`${controller}/${dataPayload._id ?? '0'}`, { ...dataPayload })
    .then((res) => res);

export const getAllUsers = (
  filterOrParams: string | GetAllUsersParams = ''
): Promise<User[]> => {
  const params =
    typeof filterOrParams === 'string'
      ? { filter: filterOrParams }
      : filterOrParams;
  const searchParams = new URLSearchParams({
    searchValue: params.filter ?? '',
  });

  if (params.currentActiveContractOnly) {
    searchParams.set('currentActiveContractOnly', 'true');
  }

  return httpApi
    .get<User[]>(`${controller}?${searchParams.toString()}`, {})
    .then((res) => res?.data);
};

export const deleteUser = (userId: string): Promise<ResponseGeneral> =>
  httpApi
    .delete<ResponseGeneral>(`${controller}/${userId}`, {})
    .then((res) => res?.data);

export const resendInvitation = (userId: string): Promise<ResponseGeneral> =>
  httpApi
    .get<ResponseGeneral>(`${controller}/resend-invitation/${userId}`, {})
    .then((res) => res?.data);

export const getEmployeesWithSchedulesOfToday = async (): Promise<
  EmployeeWithScheduleOfToday[]
> =>
  httpApi
    .get<
      EmployeeWithScheduleOfToday[]
    >(`${controller}/get-employees-with-schedules-of-today`, {})
    .then((res) => res?.data);

export const getUpcomingBirthdays = async (): Promise<
  UpcomingEmployeeEvent[]
> =>
  httpApi
    .get<UpcomingEmployeeEvent[]>(`${controller}/get-upcoming-birthdays`, {})
    .then((res) => res?.data);

export const getUpcomingSeniorityAnniversaries = async (): Promise<
  UpcomingEmployeeEvent[]
> =>
  httpApi
    .get<
      UpcomingEmployeeEvent[]
    >(`${controller}/get-upcoming-seniority-anniversaries`, {})
    .then((res) => res?.data);

export const employeeMe = (): Promise<User> => {
  return httpApi.get<User>(`${controller}/me`, {}).then((res) => res?.data);
};

export const employeeExists = (
  idEmployee: string
): Promise<{ exists: boolean }> => {
  return httpApi
    .get<{ exists: boolean }>(`${controller}/employeeExists/${idEmployee}`, {})
    .then((res) => res?.data);
};

export const sendImageToQueue = (imageName: string): Promise<JSON> => {
  return httpApi
    .post<JSON>(`${controller}/imageQueue`, { imageName })
    .then((res) => res?.data);
};

export const getNextEmployeeId = (): Promise<{ nextEmployeeId: string }> => {
  return httpApi
    .get<{ nextEmployeeId: string }>(`${controller}/get-next-employee-id`, {})
    .then((res) => res?.data);
};
